import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HowItWorks from "../pages/how-it-works/page";
import GoldStrategy from "../pages/gold-strategy/page";
import TradeJournal from "../pages/trade-journal/page";
import Mt5Setup from "../pages/mt5-setup/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/gold-strategy",
    element: <GoldStrategy />,
  },
  {
    path: "/trade-journal",
    element: <TradeJournal />,
  },
  {
    path: "/mt5-setup",
    element: <Mt5Setup />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;